let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hWdy3")).then(() => parcelRequire('a73CT'));